import * as React from 'react';

import { CardController } from 'src/app/shared/card.controller';
import { QuoteListView } from 'src/app/bookings/quotes/list/quote-list.view';

interface Props extends ComponentViewProps<DataSet<QuoteSummary>> {
	history?: any;
	mode: ControlMode;
}

export const ClientQuoteListController: React.SFC<Props> = (props: Readonly<Props>): JSX.Element => {
	const { model, mode, setBusy } = props;
	if (model == null) {
		return null;
	}

	return (
		<CardController
			icon="shopping"
			className="card-borderless"
			title="Quotes"
			mode={mode}>
			<QuoteListView
				readonly
				model={model}
				setBusy={setBusy}
				hiddenColumns={['managedByUserName', 'clientDisplayName']}
				onItemDoubleClicked={handleQuoteDoubleClick}
			/>
		</CardController>
	);
};

const handleQuoteDoubleClick = (item: QuoteSummary): void => {
	const { history } = this.props;
	if (history) {
		history.push(`/bookings/quotes/${item == null ? 'new' : item.id}`);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/client-quote-list.controller.tsx